import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined';
import MailOutlinedIcon from '@mui/icons-material/MailOutlined';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import { CustomerWithId } from '../../../models/customer.model';
import { ROUTES } from '../../../common/constants/routes';
import { ProfileRow } from '../../../common/profiles-list/ProfileRow';
import { CATEGORY_CARD_ACCENTS } from '../../../common/category-card/types';

type CustomerRowProps = {
  customer: CustomerWithId;
  navigateToDocs: (id: number) => void;
  handleEdit: (id: number) => void;
  handleDelete: (id: number) => void;
};

export const CustomerRow: React.FC<CustomerRowProps> = ({
  customer,
  navigateToDocs,
  handleDelete,
  handleEdit,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <ProfileRow
      idPrefix='customerRow'
      profileId={customer.id}
      title={customer.customer_name ?? ''}
      icon={<SupportAgentOutlinedIcon />}
      accent={CATEGORY_CARD_ACCENTS.Customers}
      details={[
        {
          id: 'customerRowEmailCell',
          icon: <MailOutlinedIcon fontSize='inherit' />,
          label: t('labels.email'),
          value: customer.email_address,
        },
        {
          id: 'customerRowWebsiteCell',
          icon: <LanguageOutlinedIcon fontSize='inherit' />,
          label: t('labels.website'),
          value: customer.website,
        },
      ]}
      onOpen={() => navigate(`${ROUTES.CUSTOMER_PROFILES}/${customer.id}`)}
      onDocuments={() => navigateToDocs(customer.id)}
      onEdit={() => handleEdit(customer.id)}
      onDelete={() => handleDelete(customer.id)}
    />
  );
};
